// @todo: check this component since upgrading 
import { Dialog, DialogDescription, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import {
  Fragment,
  FunctionComponent,
  KeyboardEventHandler,
  ReactNode
} from 'react'
import { Icon } from 'utils'

export interface ModalInterface {
  isOpen: boolean
  description?: string
  title?: string
  maxWidth?: number | string
  isLarge?: boolean
  handleClose?: () => void
  children?: ReactNode
}
export const Modal: FunctionComponent<ModalInterface> = ({
  isOpen,
  description,
  title,
  isLarge,
  maxWidth = 545,
  handleClose,
  children
}) => {
  const handleEsc: KeyboardEventHandler = (event) => {
    if (event.key === 'Escape' && handleClose) {
      handleClose()
    }
  }

  return (
    <Transition show={isOpen}>
      <Dialog open={isOpen} onClose={handleClose ?? (() => {})}>
        <div
          className={`flex justify-center ${
            isLarge ? 'items-start' : 'items-center'
          } h-screen overflow-y-scroll`}
          onKeyDown={handleEsc}
          style={{
            backgroundColor: 'rgba(51,51,51,0.8)',
            opacity: 1,
            zIndex: 101,
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}
        >
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogOverlay
              className="h-screen"
              onClick={handleClose ?? (() => {})}
            />
          </TransitionChild>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="p-8 w-full" style={{ maxWidth }}>
              <div className="transition-opacity transform bg-white p-8 sm:p-12 rounded-lg relative">
                <DialogTitle className="h3 mt-0">
                  {title ?? 'Modal'}
                </DialogTitle>
                <DialogDescription className="h5 mt-10">
                  {description ?? ''}
                </DialogDescription>
                {handleClose && (
                  <button
                    onClick={handleClose}
                    tabIndex={0}
                    type="button"
                    className="cursor-pointer"
                    style={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      height: 24,
                      width: 24
                    }}
                  >
                    <Icon id="#cross" fill="#007497" height={16} width={16} />
                  </button>
                )}
                <div>{children}</div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  )
}
